import React, {useEffect, useState} from 'react'
import useProductUsageHistoryStyles from 'pages/ProductUsageHistory/style'
import CardWithTitle from 'components/atoms/CardWithTitle'
import {
  LIST_TABS,
  ACTIVE_PRODUCT,
  DISCONTINUED_PRODUCT,
} from 'pages/ProductUsageHistory/constant'
import {useTranslation} from 'react-i18next'
import {Button} from '@material-ui/core'
import ActiveProduct from 'pages/ProductUsageHistory/Component/ActiveProduct'
import NotActiveProduct from 'pages/ProductUsageHistory/Component/NotActiveProduct'
import useProductUsageHistory from 'features/productUsageHistory/useProductUsageHistory'

const ProductUsageHistory = () => {
  const classes = useProductUsageHistoryStyles()
  const {t} = useTranslation()
  const [activeTabs, setActiveTabs] = useState<number>(0)
  const {fetchLicenseWithItem, listActive, listDiscontinue} =
    useProductUsageHistory()

  useEffect(() => {
    fetchLicenseWithItem()
    setActiveTabs(ACTIVE_PRODUCT)
  }, [])

  return (
    <CardWithTitle>
      <div className={classes.tabsUnderline}>
        {LIST_TABS.map((item) => (
          <div key={item.id}>
            <Button
              onClick={() => setActiveTabs(item.id)}
              className={`${classes.tabUnderline} ${
                activeTabs === item.id ? classes.activeTabs : ''
              }`}
            >
              {t(item.label)}
            </Button>
            {activeTabs === item.id && <div className={classes.active} />}
          </div>
        ))}
        <div className={classes.underlineIndicator} />
      </div>
      {activeTabs === ACTIVE_PRODUCT && (
        <ActiveProduct data={listActive} onUpdateLog={fetchLicenseWithItem} />
      )}
      {activeTabs === DISCONTINUED_PRODUCT && (
        <NotActiveProduct
          data={listDiscontinue}
          onUpdateLog={fetchLicenseWithItem}
        />
      )}
    </CardWithTitle>
  )
}

export default ProductUsageHistory
